// extracted by mini-css-extract-plugin
module.exports = {"hidden":"ellipsisText_hidden__OB6MY","textEmphasis":"ellipsisText_textEmphasis__yAaU3","ellipsisTextArea":"ellipsisText_ellipsisTextArea__29Q_x"};